export const dateForNotification = () => {
  const today = new Date();
  const addedDaysDate = today.setDate(today.getDate() + 31);
  return addedDaysDate
};

export const countDayOfExperiation = (date) => {
    const daysOfMsec = new Date(date) - new Date();
    const dayCounted = Math.floor(daysOfMsec / 86400000);
    return dayCounted;
  };
